"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerSaraiva = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("date-fns");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));

var _dateFns2 = _interopRequireDefault(require("@date-io/date-fns"));

var _pickers = require("@material-ui/pickers");

var _format = _interopRequireDefault(require("date-fns/format"));

var _core = require("@material-ui/core");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LocalizedUtils = /*#__PURE__*/function (_DateFnsUtils) {
  _inherits(LocalizedUtils, _DateFnsUtils);

  var _super = _createSuper(LocalizedUtils);

  function LocalizedUtils() {
    _classCallCheck(this, LocalizedUtils);

    return _super.apply(this, arguments);
  }

  _createClass(LocalizedUtils, [{
    key: "getCalendarHeaderText",
    value: function getCalendarHeaderText(date) {
      return (0, _format.default)(date, 'MMMM yyyy', {
        locale: _ptBR.default
      }).charAt(0).toUpperCase() + (0, _format.default)(date, 'MMMM yyyy', {
        locale: _ptBR.default
      }).slice(1);
    }
  }, {
    key: "getDatePickerHeaderText",
    value: function getDatePickerHeaderText(date) {
      return (0, _format.default)(date, 'EEEEEE, dd MMMM', {
        locale: _ptBR.default
      }).charAt(0).toUpperCase() + (0, _format.default)(date, 'EEEEEE, dd MMMM', {
        locale: _ptBR.default
      }).slice(1);
    }
  }]);

  return LocalizedUtils;
}(_dateFns2.default);

var useStyles = (0, _core.makeStyles)(function () {
  return {
    input: {
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: 10,
        '& input': {
          cursor: 'pointer'
        }
      },
      '& .MuiIconButton-root': {
        color: 'rgba(0, 0, 0, 0.87)'
      }
    },
    marginInput: {
      '& .MuiFormControl-marginNormal': {
        margin: 0
      }
    },
    calendar: {
      '& .MuiPickersCalendar-transitionContainer': {
        marginBottom: 4
      }
    }
  };
});

var DatePickerSaraiva = function DatePickerSaraiva(_ref) {
  var error = _ref.error,
      disabled = _ref.disabled,
      label = _ref.label,
      helperText = _ref.helperText,
      value = _ref.value,
      onChange = _ref.onChange,
      size = _ref.size;
  var classes = useStyles();
  var keyboardButtonRef = (0, _react.useRef)();
  var inputRef = (0, _react.useRef)();

  function onInputAdornmentRef(el) {
    if (!el) return;
    inputRef.current = el.parentNode.querySelector('input');
  }

  return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: LocalizedUtils,
    locale: _ptBR.default
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    justify: "space-around",
    className: classes.marginInput
  }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, {
    autoOk: true,
    views: ['year', 'month', 'date'],
    error: error,
    disabled: disabled,
    variant: "inline",
    inputVariant: "outlined",
    format: "dd/MM/yyyy",
    margin: "normal",
    id: "date-picker-inline",
    label: label,
    helperText: helperText,
    value: value,
    onChange: onChange,
    onClick: function onClick() {
      return keyboardButtonRef.current.click();
    },
    onOpen: function onOpen() {
      return inputRef.current.blur();
    },
    KeyboardButtonProps: {
      'aria-label': 'change date',
      ref: keyboardButtonRef
    },
    rightArrowButtonProps: {
      style: {
        marginRight: 16
      }
    },
    leftArrowButtonProps: {
      style: {
        marginLeft: 16
      }
    },
    className: classes.input,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    },
    InputAdornmentProps: {
      ref: onInputAdornmentRef
    },
    PopoverProps: {
      className: classes.calendar
    }
  })));
};

exports.DatePickerSaraiva = DatePickerSaraiva;
DatePickerSaraiva.propTypes = {
  /**
   * Se true, o contorno do Input fica vermelho
   */
  error: _propTypes.default.bool,

  /**
   * Se true, o input fica desabilitado (cinza e sem poder ser acessado)
   */
  disabled: _propTypes.default.bool,

  /**
   * Label que fica como placeholder no input e que fica sobre o input ao ser selecionado
   */
  label: _propTypes.default.string,

  /**
   * Texto de auxilio que fica abaixo do input de select
   */
  helperText: _propTypes.default.string,

  /**
   * Valor selecionado da data
   */
  value: _propTypes.default.string.isRequired,

  /**
   * Funcao utilizada para selecionar o valor da data
   */
  onChange: _propTypes.default.func,
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
DatePickerSaraiva.defaultProps = {
  error: false,
  disabled: false,
  label: 'Escolha uma Data',
  helperText: '',
  onChange: null,
  size: 'md'
};